// Blog carousel: arrows and the scroll progress line.
//
// Mirrors the browse-collections carousel so both sections behave identically.
// The track is a native overflow scroller, so swiping works with no JS.

function initBlogCarousel(root) {
  if (root.dataset.blogCarouselInit) return;
  root.dataset.blogCarouselInit = '1';

  const track = root.querySelector('[data-blog-track]');
  if (!track) return;

  const prev = root.querySelector('[data-blog-prev]');
  const next = root.querySelector('[data-blog-next]');
  const thumb = root.querySelector('[data-blog-thumb]');
  let ticking = false;

  function step() {
    const item = track.querySelector('.blog-posts__item');
    if (!item) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function update() {
    ticking = false;
    const max = track.scrollWidth - track.clientWidth;

    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= max - 1;

    if (thumb) {
      const ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
      thumb.style.width = Math.min(ratio * 100, 100) + '%';
      thumb.style.insetInlineStart = (track.scrollLeft / track.scrollWidth) * 100 + '%';
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  prev?.addEventListener('click', function () {
    track.scrollBy({ left: -step(), behavior: 'smooth' });
  });
  next?.addEventListener('click', function () {
    track.scrollBy({ left: step(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
}

function bootBlogCarousel(scope) {
  (scope || document).querySelectorAll('[data-blog-carousel]').forEach(initBlogCarousel);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    bootBlogCarousel();
  });
} else {
  bootBlogCarousel();
}

document.addEventListener('shopify:section:load', function (e) {
  bootBlogCarousel(e.target);
});
